/**
 * Phase 18.16-B Batch 1 — /zakelijk + /zakelijke-zendingen + /business (CMS-driven).
 */
import React from "react";
import SEO from "../components/SEO";
import ServicePageCmsWrapper from "../components/ServicePageCmsWrapper";

const BUSINESS_FALLBACK = {
  page_banner: {
    eyebrow: "Zakelijke zendingen",
    title: "Zakelijke cargo,",
    highlight: "betrouwbaar",
    subtitle: "B2B cargo voor webshops, leveranciers, groothandel en terugkerende zendingen vanuit Nederland naar de Caribbean.",
    badges: [
      { icon: "briefcase", label: "Custom contracten" },
      { icon: "package", label: "Consolidatie & pickup" },
      { icon: "support", label: "Account manager" },
    ],
    cta_primary_label: "Zakelijke offerte aanvragen",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Mail ons",
    cta_secondary_url: "mailto:info@5999cargo.nl",
  },
  intro: {
    eyebrow: "B2B oplossingen",
    title: "Voor webshops, leveranciers en groothandel",
    subtitle: "Consolidatie, pickup, documenten en persoonlijke account management — wij ontzorgen uw zakelijke zendingen volledig.",
  },
  cta_band: {
    title: "Klaar voor een zakelijk gesprek?",
    description: "Plan een vrijblijvend gesprek met onze account managers.",
    cta_primary_label: "Zakelijke offerte aanvragen",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Mail ons",
    cta_secondary_url: "mailto:info@5999cargo.nl",
  },
  cards: [],
};

export default function ZakelijkPage() {
  return (
    <>
      <SEO
        title="Zakelijke zendingen | 5999Cargo"
        description="B2B cargo voor webshops, leveranciers en groothandel naar de Caribbean — consolidatie, pickup en account management."
      />
      <ServicePageCmsWrapper
        slug="business"
        fallback={BUSINESS_FALLBACK}
        testid="business-page"
      />
    </>
  );
}
